import AssetsListAssetPreviewHeader from "./AssetsListAssetPreviewHeader";
import AssetsListAssetPreviewStage from "./AssetsListAssetPreviewStage";

/**
 * The whole composition in one place: an opaque panel laid over the assets
 * grid, header above media. Not a modal — it is positioned against the editor
 * area it covers, so the assets list strip below it stays live and anchored.
 *
 * `absolute inset-0` rather than `fixed`: the parent decides what gets covered,
 * which is what keeps the strip out from under it.
 *
 * @input {assetName: 'Kick off', listName: 'Goal reel', asset: {mediaType: 'video'}}
 */
export default function AssetsListAssetPreviewLayout({
  asset,
  assetName,
  listName,
  mediaKey,
  initialTrimInTime,
  initialTrimOutTime,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  onTrimChange,
  onMediaInfoChange,
  onRemoveFromList,
  onClose,
}) {
  return (
    <div
      id="AssetsListAssetPreview"
      className="AssetsListAssetPreview absolute inset-0 z-40 flex flex-col bg-background @container">
      <AssetsListAssetPreviewHeader
        assetName={assetName}
        listName={listName}
        onRemoveFromList={onRemoveFromList}
        onClose={onClose}
      />

      <AssetsListAssetPreviewStage
        asset={asset}
        mediaKey={mediaKey}
        initialTrimInTime={initialTrimInTime}
        initialTrimOutTime={initialTrimOutTime}
        hasPrevious={hasPrevious}
        hasNext={hasNext}
        onPrevious={onPrevious}
        onNext={onNext}
        onTrimChange={onTrimChange}
        onMediaInfoChange={onMediaInfoChange}
      />
    </div>
  );
}
